import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const ApartmentSizeHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="apartment_size" t={t}>
      <Box mb={3}>
        <H3>Wohnungsgröße</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Haben Sie und Ihr Vermieter mietvertraglich nichts anderes vereinbart, sind die Kostenpositionen nach dem
          Anteil der Wohnfläche umzulegen. Dabei geht es um die
          <b>tatsächliche Wohnfläche</b>
          der Wohnung.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          In einigen Fällen
          <b>unterscheidet</b>
          sich die Quadratmeterzahl im Mietvertrag von der in der Nebenkostenabrechnung angegebenen Fläche. Laut
          neuestem Urteil des BGH ist jedoch unerheblich, welche Wohnfläche im Mietvertrag vereinbart wurde. Es wird
          generell davon ausgegangen, dass die
          <b>Größe in der Nebenkostenabrechnung</b>
          die tatsächliche Größe des Wohnraumes beschreibt.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          <b>Bitte tragen Sie die Quadratmeterzahl ein, die in Ihrer Nebenkostenabrechnung angegeben ist!</b>
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default ApartmentSizeHelp;
